import * as React from 'react';
import { useSelectionListItemContainer } from './hooks/useSelectionListItemContainer.js';

var SelectionListItemContainer = /*#__PURE__*/React.memo(function (props) {
  var children = props.children;
  var _useSelectionListItem = useSelectionListItemContainer(),
    containerProps = _useSelectionListItem.containerProps;
  return /*#__PURE__*/React.createElement("div", containerProps, children);
});

export { SelectionListItemContainer };
//# sourceMappingURL=SelectionListItemContainer.js.map
